import { Input } from '@src/design-system/input';
import { Link2Icon } from 'lucide-react';
import { useDebounceCallback } from '@shared/hooks/use-debounce-args';

import type { TField } from '@shared/types/field';
import type { TDynamicFilterProps } from '../filter-popover-content/dynamic-filters/dynamic-filter-value-input';

const typeMapper: Partial<Record<TField['type'], string>> = {
  SHORT_ANSWER: 'text',
  NUMBER: 'number',
  EMAIL: 'email',
  LINK: 'url',
};

export function DynamicTextFilter({
  addOrEditDynamicFilter,
  dynamicField,
  values,
  onChange,
}: TDynamicFilterProps) {
  const debounced = useDebounceCallback(
    (values: string[]) => addOrEditDynamicFilter(values),
    500
  );

  const fieldType =
    dynamicField && 'type' in (dynamicField as { type?: string })
      ? (dynamicField as { type?: string }).type
      : undefined;

  return (
    <Input
      type={typeMapper[fieldType as keyof typeof typeMapper]}
      prefixIcon={
        fieldType === 'LINK' && (
          <Link2Icon
            size={20}
            className='text-gray-600'
          />
        )
      }
      className='max-w-full'
      placeholder='Write'
      size={'sm'}
      onChange={(e) => {
        const value = e.target.value.trim();
        debounced([value]);
        onChange([value]);
      }}
      value={values[0] || ''}
    />
  );
}
